export const TOOLS_ICON_TITLE_PLACEHOLDER = 'Selected survey';

export const BACKGROUND_COLOR_SELECTED = '#0860A2';
export const BACKGROUND_COLOR_NOT_SELECTED = '#738eb5';

export const TOOLS_OPTIONS_OBJECT = {
  table: {
    label: 'table',
  },
  chart: {
    label: 'chart',
  },
  line: {
    label: 'line',
  },
  map: {
    label: 'map',
  },
};

export const COLUMN_CHARACTERISTIC = 'CharacteristicLabel';
export const COLUMN_COUNTRY = 'CountryName';
export const COLUMN_SURVEY = 'SurveyLabel';
export const COLUMN_VALUE = 'Value';
